import type { FC, PropsWithChildren } from 'react';
import cn from 'classnames';
import styles from './Card.module.scss';
import { Title } from './components/Title';
import { BackButton } from './components/BackButton';

interface Props extends PropsWithChildren {
  className?: string;
}

interface Component extends FC<Props> {
  Title: typeof Title;
  BackButton: typeof BackButton;
}

export const Card: Component = ({ children, className }) => {
  return <div className={cn(styles.card, className)}>{children}</div>;
};

Card.Title = Title;
Card.BackButton = BackButton;
